import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4197d0e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lang-msg-box-wrap" }
const _hoisted_2 = { class: "lang-msgbox-title-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "style-l" }, null, -1))
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "style-r" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar-line" }, null, -1))
const _hoisted_7 = { class: "msgbox-body-wrap" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "lang-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "lang-msg-box-root",
    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('languagetitle')), 1),
        _hoisted_5,
        _createElementVNode("div", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["list-item", { active: lang.code === _ctx.langCode }]),
            key: index,
            onClick: ($event: any) => (_ctx.handleSelectLanguage(lang.code))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["flag", lang.code])
            }, null, 2),
            _createElementVNode("div", _hoisted_9, _toDisplayString(lang.name), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["icon", 
                            lang.code === _ctx.langCode
                                ? 'icon-dialog-radiobutton-selected'
                                : 'icon-dialog-radiobutton-unselected'
                        ])
            }, null, 2)
          ], 10, _hoisted_8))
        }), 128)),
        _createElementVNode("div", {
          class: "btn-confirm",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmLanguage && _ctx.confirmLanguage(...args)))
        }, _toDisplayString(_ctx.t('confirm')), 1)
      ])
    ])
  ]))
}